var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 333,
    viewBox: "0 0 224 333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72406 99.9441L36.026 134.357L2.72406 168.77C0.955809 157.56 0 146.078 0 134.357C0 122.636 0.955809 111.146 2.72406 99.9441Z",
    fill: "#28282E",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2929 26.8313L132.341 134.35L28.2929 241.878C22.4386 231.598 17.3967 220.774 13.2549 209.481L85.9601 134.35L13.2628 59.2278C17.3967 47.9351 22.4386 37.1116 28.2929 26.8313Z",
    fill: "#28282E",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.517 158.323L72.2854 295.992C63.9619 288.642 56.204 280.633 49.0991 272.024L182.323 134.355L205.517 158.323Z",
    fill: "#28282E",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.323 134.355L49.0991 -3.31339C56.204 -11.9146 63.954 -19.9314 72.2934 -27.2733L205.517 110.395L182.323 134.355Z",
    fill: "#28282E",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.498 58.775L101.443 -48.7441C111.391 -54.802 121.865 -60.0121 132.793 -64.2839L205.498 10.8388L278.196 -64.2839C289.124 -60.0121 299.598 -54.7938 309.546 -48.7441L205.498 58.775Z",
    fill: "#28282E",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.209 333L205.512 257.877L132.806 333C121.878 328.728 111.404 323.518 101.456 317.469L205.512 209.941L309.559 317.46C299.611 323.51 289.137 328.72 278.209 333Z",
    fill: "#28282E",
    fillOpacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.685 134.355L361.909 272.024C354.804 280.625 347.046 288.642 338.714 295.984L205.499 158.323L228.685 134.355Z",
    fill: "#28282E",
    fillOpacity: 0.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.909 -3.30761L228.685 134.353L205.499 110.393L338.714 -27.2758C347.046 -19.9339 354.804 -11.917 361.909 -3.30761Z",
    fill: "#28282E",
    fillOpacity: 0.4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.686 134.356L205.5 158.324L182.306 134.356L205.5 110.396L228.686 134.356Z",
    fill: "#28282E",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgImg);
export default __webpack_public_path__ + "static/media/bg-img.399fe0be1b6031316675a6c6cce51bec.svg";
export { ForwardRef as ReactComponent };